export const DAY_FORMATE = 'YYYY-MM-DD'